import React from "react";
import { services } from "../data/data";

const Services = () => {
  return (
    <div className="py-32">
      <div class="container mx-auto px-5">
        <div>
          <h3 className="text-6xl font-bold pb-5">Services</h3>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-14 pt-16">
          {services.map((item, index) => (
            <div
              class="p-6 rounded-lg border-b-primary border-2 hover:shadow-2xl delay-100 cursor-pointer"
              key={index}
            >
              <div class="mb-5 text-primary text-4xl">{item.icon}</div>

              <h3 class="text-xl font-bold mb-3 text-primary">{item.title}</h3>
              <p class="text-sm text-gray-600 leading-tight">{item.details}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;
